export default __webpack_public_path__ + "static/media/orangeBg.6dea6bee.png";